export default (editor, opts = {}) => {
  const bm = editor.BlockManager;
  const style = `<style></style>
  `;
  bm.add(opts.name, {
    label: `
    <div style="display: flex; justify-content: center" >
    <svg version="1.1" class="icon-lofty-component-block" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        width="40px" height="40px" viewBox="0 0 600 600" style="enable-background:new 0 0 600 600;" xml:space="preserve">
      <g>
        <path d="M579.76,590.703H15.895c-4.328,0-7.893-3.538-7.893-7.946V26.022c0-4.354,3.564-7.893,7.893-7.893
          H579.76c4.354,0,7.893,3.538,7.893,7.893v556.734C587.652,587.165,584.113,590.703,579.76,590.703z M23.842,574.863h547.971V33.915
          H23.842V574.863z"/>
      </g>
      <g>
      <path d="M374.242,225.338H70.535c-3.691,0-6.691-2.999-6.691-6.69s3-6.69,6.691-6.69h303.708
        c3.738,0,6.738,2.999,6.738,6.69S377.98,225.338,374.242,225.338z"/>
      <path d="M374.242,346.371H70.535c-3.691,0-6.691-3-6.691-6.691s3-6.691,6.691-6.691h303.708
        c3.738,0,6.738,3,6.738,6.691S377.98,346.371,374.242,346.371z"/>
      <path d="M374.242,467.447H70.535c-3.691,0-6.691-2.998-6.691-6.689s3-6.691,6.691-6.691h303.708
        c3.738,0,6.738,3,6.738,6.691S377.98,467.447,374.242,467.447z"/>
      <path d="M455.869,346.371h-17.58c-3.691,0-6.691-3-6.691-6.691s3-6.691,6.691-6.691h17.58
        c3.691,0,6.691,3,6.691,6.691S459.561,346.371,455.869,346.371z"/>
      <path d="M455.869,467.447h-17.58c-3.691,0-6.691-2.998-6.691-6.689s3-6.691,6.691-6.691h17.58
        c3.691,0,6.691,3,6.691,6.691S459.561,467.447,455.869,467.447z"/>
      <path d="M449.824,229.86c-1.615,0-3.275-0.601-4.568-1.8l-17.719-16.611
        c-2.699-2.492-2.859-6.737-0.322-9.459c2.537-2.723,6.783-2.815,9.459-0.323l13.012,12.182l73.828-73.367
        c2.631-2.584,6.854-2.584,9.459,0.047c2.607,2.63,2.584,6.875-0.045,9.459l-78.396,77.935
        C453.238,229.214,451.531,229.86,449.824,229.86z"/>
      </g>
    </svg>
    </div>
    <div class="gjs-block-label">
      ${opts.labelComponent}
    </div> 
    `,
    category: opts.category,
    attributes: {title: 'Visualiza o lee una lista de elementos contenido en la base de datos..', id: 'component-neogetdb-lofty-editor'},
    content: `
      <div
        data-gjs-resizable="{bc: 1}"
        data-gjs-slugLofty="readerCoreContainer"
        data-gjs-name="Contenedor Principal de lectura de Coleccion de Datos"
        style="min-height: 100px; padding: 10px;"
        data-gjs-droppable="false"
      >
        <div
          data-gjs-resizable="{bc: 1}"
          data-gjs-droppable="true"
          data-gjs-editable="false"
          data-gjs-selectable="true"
          data-gjs-hoverable="true"
          data-gjs-layerable="true"
          data-gjs-type="default"
          data-gjs-slugLofty="CoreGetDatabaseRender"
          data-gjs-name="Renderizar campos de Coleccion de Datos"
          style="min-height: 100px; padding: 10px;  display: none;"
          data-gjs-draggable="false"
        >
        </div>
        <div
          data-gjs-resizable="{bc: 1}"
          data-gjs-droppable="true"
          data-gjs-editable="false"
          data-gjs-selectable="true"
          data-gjs-hoverable="true"
          data-gjs-layerable="true"
          data-gjs-type="default"
          data-gjs-slugLofty="ErrorSectionRead"
          data-gjs-name="Contenedor de Error de Lectura de Coleccion de Datos"
          style="min-height: 100px; padding: 10px; display: none"
          data-gjs-draggable="false"
        >
        </div>
        <div
          data-gjs-resizable="{bc: 1}"
          data-gjs-droppable="true"
          data-gjs-editable="false"
          data-gjs-draggable="false"
          data-gjs-selectable="true"
          data-gjs-hoverable="true"
          data-gjs-layerable="true"
          data-gjs-type="default"
          data-gjs-slugLofty="NoDataSectionRead"
          data-gjs-name="Contenedor de Sin Datos de Lectura de Coleccion de Datos"
          style="min-height: 100px; padding: 10px; display: none"
        >
        </div>
        <div
          data-gjs-resizable="{bc: 1}"
          data-gjs-droppable="true"
          data-gjs-editable="false"
          data-gjs-draggable="false"
          data-gjs-selectable="true"
          data-gjs-hoverable="true"
          data-gjs-layerable="true"
          data-gjs-type="default"
          data-gjs-slugLofty="LoadingSectionRead"
          data-gjs-name="Contenedor de Carga de Lectura de Coleccion de Datos"
          style="min-height: 100px; padding: 10px; display: none"
        >
        </div>
      </div>
    ${style}`,
  });
};
